import { DateTime } from 'luxon';

export const isDisabledDate = (date: Date) => {
  const now = new Date();
  return (
    date.getUTCFullYear() === now.getUTCFullYear() &&
    date.getUTCMonth() === now.getUTCMonth() &&
    date.getUTCDate() < now.getUTCDate()
  );
};
export const isSameDate = (date: Date) => {
  const now = new Date();
  return (
    date.getUTCFullYear() === now.getUTCFullYear() &&
    date.getUTCMonth() === now.getUTCMonth() &&
    date.getUTCDate() === now.getUTCDate()
  );
};

export const isDisabledHour = (hour: number, date: Date) => {
  if (isSameDate(date)) {
    return hour < new Date().getHours();
  }
  return false;
};

export const isDisabledMinute = (min: number, date: Date) => {
  if (isSameDate(date) && new Date().getHours() === date.getHours()) {
    return min < new Date().getMinutes() + 10;
  }
  return false;
};

export const getDefaultDate = () => {
  const now = new Date();
  now.setHours(now.getHours() + 1);
  // const year = now.getFullYear();
  // const month = ('0' + (now.getMonth() + 1)).slice(-2);
  // const nDate = ('0' + now.getDate()).slice(-2);
  // const hour = ('0' + now.getHours()).slice(-2);
  // const min = ('0' + now.getMinutes()).slice(-2);
  // const defaultDate = new Date(`${year}-${month}-${nDate}T${hour}:${min}:00`);

  const defaultDate = new Date(getDateStr(now));
  return defaultDate;
};

export const getSuggestedTimeStr = () => {
  const d = getDefaultDate();
  const hour = ('0' + d.getHours()).slice(-2);
  const min = ('0' + d.getMinutes()).slice(-2);

  return `${hour}:${min}`;
};

export const getDateStr = (d: Date) => {
  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const nDate = ('0' + d.getDate()).slice(-2);
  const hour = ('0' + d.getHours()).slice(-2);
  const min = ('0' + d.getMinutes()).slice(-2);
  return `${year}-${month}-${nDate}T${hour}:${min}:00`;
};

export const getEtaMins = (d: Date) => {
  const mins = DateTime.fromJSDate(d)
    .diff(DateTime.now(), 'minutes')
    .toObject().minutes;
  const etaMins = mins && Math.ceil(mins) >= 0 ? Math.ceil(mins) : -1;
  return etaMins;
};
